import React from 'react';

export const QuickThankYouRecipientIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
	return (
		<svg ref={ref} width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33377 1.8187C6.1376 1.75455 6.90071 1.43846 7.51447 0.915419C8.94672 -0.30514 11.0533 -0.30514 12.4855 0.915419C13.0993 1.43846 13.8624 1.75455 14.6662 1.8187C16.5421 1.96839 18.0316 3.45794 18.1813 5.33377C18.2455 6.1376 18.5615 6.90071 19.0846 7.51447C20.3051 8.94672 20.3051 11.0533 19.0846 12.4855C18.5615 13.0993 18.2455 13.8624 18.1813 14.6662C18.0316 16.5421 16.5421 18.0316 14.6662 18.1813C13.8624 18.2455 13.0993 18.5615 12.4855 19.0846C11.0533 20.3051 8.94672 20.3051 7.51447 19.0846C6.90071 18.5615 6.1376 18.2455 5.33377 18.1813C3.45794 18.0316 1.96839 16.5421 1.8187 14.6662C1.75455 13.8624 1.43846 13.0993 0.915419 12.4855C-0.30514 11.0533 -0.30514 8.94672 0.915419 7.51447C1.43846 6.90071 1.75455 6.1376 1.8187 5.33377C1.96839 3.45794 3.45794 1.96839 5.33377 1.8187Z"
				fill="#118342"
			/>
			<g clipPath="url(#clip0_16981_9294)">
				<path
					d="M7.05754 14V5.805H10.1925C10.7572 5.805 11.2559 5.904 11.6885 6.102C12.1285 6.3 12.4732 6.59333 12.7225 6.982C12.9719 7.37067 13.0965 7.851 13.0965 8.423C13.0965 8.98033 12.9682 9.457 12.7115 9.853C12.4549 10.2417 12.1102 10.535 11.6775 10.733L13.5475 14H11.6335L9.60954 10.381L10.7095 11.03H8.76254V14H7.05754ZM8.76254 9.545H10.2035C10.4455 9.545 10.6545 9.49733 10.8305 9.402C11.0065 9.30667 11.1422 9.17467 11.2375 9.006C11.3402 8.83733 11.3915 8.643 11.3915 8.423C11.3915 8.19567 11.3402 7.99767 11.2375 7.829C11.1422 7.66033 11.0065 7.52833 10.8305 7.433C10.6545 7.33767 10.4455 7.29 10.2035 7.29H8.76254V9.545Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_16981_9294">
					<rect width="17" height="17" fill="white" transform="translate(1.5 1.5)" />
				</clipPath>
			</defs>
		</svg>
	);
});
QuickThankYouRecipientIcon.displayName = 'quick-thank-you-recipient-icon'; // Path: packages/common/bonus/src/assets/quick-thank-you-recipient-icon.tsx
